import { render, staticRenderFns } from "./ArtistsList.vue?vue&type=template&id=7ba81247"
import script from "./ArtistsList.vue?vue&type=script&lang=js"
export * from "./ArtistsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports